import gql from 'graphql-tag';
import { MARKET_INSIGHTS, TURNOVER_RATE } from '../../../gql/fragments';

export const marketInsightsByLicensePlaceQuery = gql`
  ${MARKET_INSIGHTS}

  query MarketInsightsByLicensePlaceQuery($licensePlate: [String!]!) {
    car: specificationByLicensePlate(licensePlate: $licensePlate) {
      vin
      ...MarketInsights
    }
  }
`;

export const marketInsightsByVinQuery = gql`
  ${MARKET_INSIGHTS}

  query MarketInsightsByVinQuery($vin: [String!]!) {
    car: specificationByVin(vin: $vin) {
      vin
      ...MarketInsights
    }
  }
`;

// Fetched separately from MarketInsights so the two temporalAnalytics aliases
// (classifiedPricePerSalesQuarter + turnoverRatePerMonth) are never in the same
// operation (avoids the gateway delegation deadlock).
export const turnoverRateByLicensePlaceQuery = gql`
  ${TURNOVER_RATE}

  query TurnoverRateByLicensePlaceQuery($licensePlate: [String!]!) {
    car: specificationByLicensePlate(licensePlate: $licensePlate) {
      vin
      ...TurnoverRate
    }
  }
`;

export const turnoverRateByVinQuery = gql`
  ${TURNOVER_RATE}

  query TurnoverRateByVinQuery($vin: [String!]!) {
    car: specificationByVin(vin: $vin) {
      vin
      ...TurnoverRate
    }
  }
`;
